if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        // More robust cart detection
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        console.log(
          "Cart element found:",
          !!this.cart,
          "Type:",
          this.cart ? this.cart.tagName : "none"
        );
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        this.upsellCheckbox = document.querySelector('[name="upsell"]');
        this.upsellProductId = this.upsellCheckbox?.getAttribute(
          "data-upsell-product-id"
        );
        // Default quantity for upsell
        this.quantity = 1;

        // Add comprehensive logging for initialization
        console.log("ProductForm initialized:", {
          upsellCheckbox: !!this.upsellCheckbox,
          upsellProductId: this.upsellProductId,
          initialQuantity: this.quantity,
          cartElement: !!this.cart,
          submitButton: !!this.submitButton,
        });

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        // Enhanced bundle quantity handling with better error checking
        setTimeout(() => {
          try {
            if (document.querySelector(".kaching-bundles__bars")) {
              const selectedOption = document.querySelector(
                ".kaching-bundles__bar--selected .kaching-bundles__bar-title"
              );
              if (selectedOption) {
                const quantityText = selectedOption.textContent.split(" ")[0];
                const parsedQuantity = parseInt(quantityText, 10);

                if (!isNaN(parsedQuantity) && parsedQuantity > 0) {
                  this.quantity = parsedQuantity;
                  console.log(`Initial quantity selected: ${this.quantity}`);
                } else {
                  console.warn(
                    `Invalid quantity text found: "${quantityText}", keeping default: ${this.quantity}`
                  );
                }
              }

              document
                .querySelectorAll(".kaching-bundles__bar")
                .forEach((bar) => {
                  bar.addEventListener("click", () => {
                    try {
                      const selectedOption = bar.querySelector(
                        ".kaching-bundles__bar-title"
                      );
                      if (selectedOption) {
                        const quantityText =
                          selectedOption.textContent.split(" ")[0];
                        const parsedQuantity = parseInt(quantityText, 10);

                        if (!isNaN(parsedQuantity) && parsedQuantity > 0) {
                          this.quantity = parsedQuantity;
                          console.log(
                            `Current quantity selected: ${this.quantity}`
                          );
                        } else {
                          console.warn(
                            `Invalid quantity text found: "${quantityText}", keeping previous: ${this.quantity}`
                          );
                        }
                      }
                    } catch (error) {
                      console.error("Error handling bundle bar click:", error);
                    }
                  });
                });
            }
          } catch (error) {
            console.error(
              "Error initializing bundle quantity handlers:",
              error
            );
          }
        }, 1000);
      }

      // Add this method to your ProductForm class
      getSectionsToRender() {
        console.log("🔍 ProductForm getSectionsToRender called");
        const sections = [
          {
            id: "cart-notification-product",
            selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
          },
          {
            id: "cart-notification-button",
          },
          {
            id: "cart-icon-bubble",
            section: "cart-icon-bubble",
            selector: ".shopify-section",
          },
        ];
        console.log("📋 Sections to render:", sections);
        return sections;
      }

      // NEW: Method to get current cart contents

      // NEW: Method to get current cart contents
      async getCartContents() {
        try {
          const response = await fetch("/cart.js");
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return await response.json();
        } catch (error) {
          console.error("Error fetching cart contents:", error);
          throw error;
        }
      }

      // NEW: Method to update existing cart item quantity
      async updateCartItem(lineIndex, newQuantity) {
        try {
          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          config.headers["Content-Type"] = "application/json";

          const updateData = {
            line: lineIndex, // Use the line index (1-based) instead of key
            quantity: newQuantity,
          };

          // Add sections if cart exists
          if (this.cart) {
            try {
              const sectionsToRender = this.cart.getSectionsToRender();
              if (sectionsToRender && Array.isArray(sectionsToRender)) {
                updateData.sections = sectionsToRender.map(
                  (section) => section.id
                );
                updateData.sections_url = window.location.pathname;
              }
            } catch (sectionError) {
              console.warn(
                "⚠️ Error getting sections to render for update:",
                sectionError
              );
            }
          }

          config.body = JSON.stringify(updateData);

          console.log("🔄 Updating cart item:", {
            lineIndex,
            newQuantity,
            updateData,
          });

          const response = await fetch("/cart/change.js", config);

          if (!response.ok) {
            const errorText = await response.text();
            throw new Error(
              `Failed to update cart item: ${response.status} - ${errorText}`
            );
          }

          return await response.json();
        } catch (error) {
          console.error("❌ Error updating cart item:", error);
          throw error;
        }
      }

      async addUpsellProduct() {
        console.log("🛒 Starting upsell product addition...");
        console.log("Upsell Product ID:", this.upsellProductId);
        console.log("Upsell Quantity:", this.quantity);
        console.log("Upsell checkbox checked:", this.upsellCheckbox?.checked);

        // Enhanced validation with detailed logging
        if (!this.upsellProductId) {
          const error = new Error("Upsell product ID is not defined");
          console.error("❌ Upsell validation failed:", error.message);
          console.log("Upsell checkbox element:", this.upsellCheckbox);
          console.log(
            "data-upsell-product-id attribute:",
            this.upsellCheckbox?.getAttribute("data-upsell-product-id")
          );
          return Promise.reject(error);
        }

        // Validate quantity
        const quantity = this.quantity || 1;
        if (isNaN(quantity) || quantity <= 0) {
          const error = new Error(`Invalid upsell quantity: ${quantity}`);
          console.error("❌ Upsell quantity validation failed:", error.message);
          return Promise.reject(error);
        }

        // Check if required globals exist
        if (typeof fetchConfig !== "function") {
          const error = new Error("fetchConfig function is not available");
          console.error("❌ Missing dependency:", error.message);
          return Promise.reject(error);
        }

        if (typeof routes === "undefined" || !routes.cart_add_url) {
          const error = new Error("routes.cart_add_url is not available");
          console.error("❌ Missing routes configuration:", error.message);
          return Promise.reject(error);
        }

        try {
          // NEW: First, check if upsell product already exists in cart
          console.log("🔍 Checking current cart contents...");
          const cartData = await this.getCartContents();

          // Find existing upsell product in cart
          const existingUpsellItemIndex = cartData.items.findIndex(
            (item) => item.variant_id == this.upsellProductId
          );

          if (existingUpsellItemIndex !== -1) {
            const existingUpsellItem = cartData.items[existingUpsellItemIndex];
            console.log("📦 Found existing upsell item in cart:", {
              index: existingUpsellItemIndex + 1, // Shopify uses 1-based indexing
              key: existingUpsellItem.key,
              currentQuantity: existingUpsellItem.quantity,
              variantId: existingUpsellItem.variant_id,
            });

            // Update the existing item's quantity using 1-based line index
            const newQuantity = existingUpsellItem.quantity + quantity;
            console.log(
              `🔄 Updating existing upsell quantity from ${existingUpsellItem.quantity} to ${newQuantity}`
            );

            return await this.updateCartItem(
              existingUpsellItemIndex + 1,
              newQuantity
            );
          } else {
            console.log("➕ No existing upsell item found, adding new item");

            // Proceed with original add logic
            const config = fetchConfig("javascript");
            config.headers["X-Requested-With"] = "XMLHttpRequest";
            delete config.headers["Content-Type"];

            // Use FormData to match the format of the main cart addition
            const upsellFormData = new FormData();
            upsellFormData.append("id", this.upsellProductId);
            upsellFormData.append("quantity", quantity);

            console.log("📦 Upsell FormData contents:");
            for (let [key, value] of upsellFormData.entries()) {
              console.log(`  ${key}: ${value}`);
            }

            // If you have sections to render, include them
            if (this.cart) {
              try {
                const sectionsToRender = this.cart.getSectionsToRender();
                if (sectionsToRender && Array.isArray(sectionsToRender)) {
                  upsellFormData.append(
                    "sections",
                    sectionsToRender.map((section) => section.id).join(",")
                  );
                  upsellFormData.append(
                    "sections_url",
                    window.location.pathname
                  );
                  console.log(
                    "📄 Added sections to render:",
                    sectionsToRender.map((s) => s.id)
                  );
                } else {
                  console.warn(
                    "⚠️ getSectionsToRender() returned invalid data:",
                    sectionsToRender
                  );
                }
              } catch (sectionError) {
                console.warn(
                  "⚠️ Error getting sections to render:",
                  sectionError
                );
                // Continue without sections - this shouldn't be fatal
              }
            } else {
              console.log(
                "ℹ️ No cart element found, proceeding without sections"
              );
            }

            config.body = upsellFormData;

            console.log(
              "🚀 Making upsell fetch request to:",
              routes.cart_add_url
            );
            console.log("🔧 Request config:", {
              method: config.method || "POST",
              headers: config.headers,
              bodyType: "FormData",
            });

            // Use the same endpoint as the main cart addition
            return fetch(`${routes.cart_add_url}`, config)
              .then((response) => {
                console.log("📡 Upsell fetch response received:", {
                  status: response.status,
                  statusText: response.statusText,
                  ok: response.ok,
                  url: response.url,
                });

                if (!response.ok) {
                  return response.text().then((errorText) => {
                    let errorData;
                    try {
                      errorData = JSON.parse(errorText);
                    } catch (parseError) {
                      console.error(
                        "❌ Failed to parse error response as JSON:",
                        parseError
                      );
                      errorData = { message: errorText, parseError: true };
                    }

                    console.error("❌ Upsell add error details:", {
                      status: response.status,
                      statusText: response.statusText,
                      errorData: errorData,
                      rawResponse: errorText,
                    });

                    throw new Error(
                      `Failed to add upsell product: ${response.status} - ${
                        errorData.message || errorText
                      }`
                    );
                  });
                }
                return response.json();
              })
              .then((data) => {
                console.log("✅ Upsell item added to cart successfully:", data);
                return data;
              })
              .catch((error) => {
                console.error("❌ Error adding upsell item to the cart:", {
                  message: error.message,
                  stack: error.stack,
                  upsellProductId: this.upsellProductId,
                  quantity: quantity,
                });
                throw error; // Re-throw to allow the main function to handle it
              });
          }
        } catch (configError) {
          console.error("❌ Error in upsell process:", configError);
          return Promise.reject(configError);
        }
      }

      onSubmitHandler(evt) {
        console.log("🎯 Form submission started");
        evt.preventDefault();

        // Add a flag to prevent double submissions
        if (this.isProcessing) {
          console.log("⏸️ Already processing a submission, aborting");
          return;
        }

        // Check if button is disabled due to no variant selected (select-size script)
        const buttonText = this.submitButtonText?.textContent?.trim();
        const isAriaDisabled =
          this.submitButton.getAttribute("aria-disabled") === "true";
        const isLoading = this.submitButton.classList.contains("loading");

        console.log("🔍 Button state check:", {
          isAriaDisabled,
          isLoading,
          buttonText,
          isProcessing: this.isProcessing,
        });

        const isSelectSizeDisabled =
          isAriaDisabled &&
          (buttonText === "Select size" || buttonText === "Sold out");

        if (isSelectSizeDisabled) {
          console.log(
            "⏸️ Submit button disabled due to variant selection requirement:",
            buttonText
          );
          return;
        }

        // Check for processing-related disabled state (our own loading state)
        if (isAriaDisabled && isLoading) {
          console.log(
            "⏸️ Submit button disabled due to loading state, aborting"
          );
          return;
        }

        // Check for any other disabled state that might interfere
        if (isAriaDisabled) {
          console.log(
            "⚠️ Submit button disabled for unknown reason, proceeding anyway. Button text:",
            buttonText
          );
        }

        this.isProcessing = true;

        console.log("📋 Form submission state:", {
          upsellCheckboxExists: !!this.upsellCheckbox,
          upsellCheckboxChecked: this.upsellCheckbox?.checked,
          upsellProductId: this.upsellProductId,
          currentQuantity: this.quantity,
        });

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        // Always use our own getSectionsToRender method
        const sectionsToRender = this.getSectionsToRender();
        console.log("📦 Using our own sections:", sectionsToRender);

        formData.append(
          "sections",
          sectionsToRender.map((section) => section.id).join(",") // Join as comma-separated string
        );
        formData.append("sections_url", window.location.pathname);

        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        console.log("🚀 Making main product fetch request");

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            console.log("📡 Main product response received:", {
              status: response.status,
              ok: response.ok,
            });

            // Clone the response before consuming it
            const responseClone = response.clone();

            // Log the raw response for debugging
            responseClone.text().then((text) => {
              console.log("📄 Raw response:", text.substring(0, 500) + "...");
            });

            return response.json();
          })
          .then((responseData) => {
            console.log("📦 Parsed response data:", responseData);

            if (responseData.status) {
              console.log("❌ Main product addition failed:", responseData);
              this.handleErrorResponse(responseData);
              return;
            }

            console.log("✅ Main product added successfully");

            // Add upsell product if conditions are met
            if (this.upsellCheckbox && this.upsellCheckbox.checked) {
              console.log("🎁 Upsell conditions met, adding upsell product...");
              return this.addUpsellProduct()
                .then((upsellResponse) => {
                  console.log("✅ Upsell addition completed successfully");
                  return responseData; // Return responseData instead of response
                })
                .catch((upsellError) => {
                  console.error(
                    "❌ Upsell addition failed, but main product was added:",
                    upsellError
                  );
                  return responseData; // Return responseData instead of response
                });
            } else {
              console.log("ℹ️ No upsell needed:", {
                checkboxExists: !!this.upsellCheckbox,
                checkboxChecked: this.upsellCheckbox?.checked,
              });
            }

            return responseData; // Return responseData instead of response
          })
          .then((responseData) => {
            console.log("🎉 Processing successful response");
            this.handleSuccessfulResponse(responseData); // Pass responseData instead of response
          })
          .catch((e) => {
            console.error("❌ Fatal error in form submission:", {
              message: e.message,
              stack: e.stack,
            });
          })
          .finally(() => {
            console.log("🔄 Finalizing purchase process");
            this.isProcessing = false; // Reset the processing flag
            this.finalizePurchaseProcess();
          });
      }

      handleErrorResponse(response) {
        console.log("❌ Handling error response:", response);

        publish(PUB_SUB_EVENTS.cartError, {
          source: "product-form",
          productVariantId: this.variantIdInput.value,
          errors: response.errors || response.description,
          message: response.message,
        });
        this.handleErrorMessage(response.description);

        const soldOutMessage =
          this.submitButton.querySelector(".sold-out-message");
        if (soldOutMessage) {
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButtonText.classList.add("hidden");
          soldOutMessage.classList.remove("hidden");
          this.error = true;
        }
      }

      handleSuccessfulResponse(responseData) {
        console.log("✅ Handling successful response");

        // if (!this.cart) {
        //   console.log("ℹ️ No cart element found, would redirect to cart page");
        //   // window.location = window.routes.cart_url;
        //   return;
        // }

        // Check if we have sections in the response
        if (responseData && responseData.sections) {
          console.log(
            "🧩 Found sections in response:",
            Object.keys(responseData.sections)
          );

          // Update the cart icon bubble
          if (responseData.sections["cart-icon-bubble"]) {
            console.log("🛒 Updating cart icon bubble");

            // Find the cart icon bubble container
            const cartIconBubbleContainer =
              document.querySelector("#cart-icon-bubble");
            if (cartIconBubbleContainer) {
              cartIconBubbleContainer.innerHTML =
                responseData.sections["cart-icon-bubble"];
              console.log("✅ Cart icon bubble updated successfully");
            } else {
              console.log("⚠️ Cart icon bubble container not found");
            }
          }
        }

        if (!this.cart) {
          console.log("ℹ️ No cart element found, would redirect to cart page");
          // window.location = window.routes.cart_url;
          return;
        }

        if (!this.error) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: this.variantIdInput.value,
            cartData: responseData,
          });
        }
        this.error = false;
        const quickAddModal = this.closest("quick-add-modal");
        if (quickAddModal) {
          document.body.addEventListener(
            "modalClosed",
            () => {
              setTimeout(() => {
                this.cart.renderContents(responseData);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(responseData);
        }
      }

      finalizePurchaseProcess() {
        this.submitButton.classList.remove("loading");
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
        this.querySelector(".loading__spinner").classList.add("hidden");
        console.log("✅ Purchase process finalized");
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
